import Text from '@cartwhl/ui/base/Text';

export default function PlanFeatures({
  plan,
}: {
  plan:
    | 'Creator'
    | 'Advanced'
    | 'Unlimited'
    | 'Professional'
    | 'Team workspace';
}) {
  if (plan === 'Creator') {
    return (
      <div className="flex flex-col">
        <Text as="p" variant="studio/body/bold/md">
          Creator
        </Text>
        <ul className="text-gray-60 mt-2 list-disc pl-4 text-sm">
          <li>150 Spins / mo</li>
          <li>Motion Library access</li>
          <li>Video to Motion access</li>
        </ul>
      </div>
    );
  }

  if (plan === 'Team workspace') {
    return (
      <div className="flex flex-col">
        <Text as="p" variant="studio/body/bold/md">
          Team workspace seat
        </Text>
        <ul className="text-gray-60 mt-2 list-disc pl-4 text-sm">
          <li>Full workspace access for this billing period</li>
          <li>Included credits and features for your team plan</li>
        </ul>
      </div>
    );
  }

  if (plan === 'Advanced' || plan === 'Unlimited') {
    return (
      <div className="flex flex-col">
        <Text as="p" variant="studio/body/bold/md">
          Advanced
        </Text>
        <ul className="text-gray-60 mt-2 list-disc pl-4 text-sm">
          <li>Everything in Professional</li>
          <li>4,500 Spins</li>
          <li>Advanced support</li>
          <li>API access</li>
        </ul>
      </div>
    );
  }

  return (
    <div className="flex flex-col">
      <Text as="p" variant="studio/body/bold/md">
        Professional
      </Text>
      <ul className="text-gray-60 mt-2 list-disc pl-4 text-sm">
        <li>Everything in Creator</li>
        <li>1,500 Spins per month</li>
        <li>Export Maya w/ extended rig features</li>
      </ul>
    </div>
  );
}
